var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradingicongreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76855 4.51953V7.62286",
    stroke: "#049981",
    strokeWidth: 1.16375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5443 7.62109H6.99263C6.56415 7.62109 6.2168 7.96845 6.2168 8.39693V11.5003C6.2168 11.9287 6.56415 12.2761 6.99263 12.2761H8.5443C8.97278 12.2761 9.32013 11.9287 9.32013 11.5003V8.39693C9.32013 7.96845 8.97278 7.62109 8.5443 7.62109Z",
    stroke: "#049981",
    strokeWidth: 1.16375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76855 12.2773V13.829",
    stroke: "#049981",
    strokeWidth: 1.16375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9746 2.96484V4.51651",
    stroke: "#049981",
    strokeWidth: 1.16375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7504 4.51953H13.1987C12.7702 4.51953 12.4229 4.86688 12.4229 5.29536V9.95036C12.4229 10.3788 12.7702 10.7262 13.1987 10.7262H14.7504C15.1788 10.7262 15.5262 10.3788 15.5262 9.95036V5.29536C15.5262 4.86688 15.1788 4.51953 14.7504 4.51953Z",
    stroke: "#049981",
    strokeWidth: 1.16375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9746 10.7266V13.0541",
    stroke: "#049981",
    strokeWidth: 1.16375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11328 2.96484V15.3782C3.11328 15.7897 3.27676 16.1844 3.56775 16.4754C3.85875 16.7664 4.25342 16.9298 4.66495 16.9298H17.0783",
    stroke: "#049981",
    strokeWidth: 1.16375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingicongreen);
export default __webpack_public_path__ + "static/media/tradingicongreen.cf8d3d1ba7834c9d4b2d2048f7e90ed1.svg";
export { ForwardRef as ReactComponent };